__webpack_require__.p = "/stardew-profit-calculator/";